import { getLeadStatusFromValue } from "shared/topchef.types";

const StatusRenderer = ({ status }: { status: string }) => {

  const currentLeadStatus = getLeadStatusFromValue(status);
  return (
    <span className={"brief-state rounded py-1 px-2 m-2 fw-bold "+ currentLeadStatus.css} title={currentLeadStatus.label}>{currentLeadStatus.label} </span>
  );

};

export default StatusRenderer;
